import { BeatoutLanguage } from "./translations";
export var TeamGameType;
(function (TeamGameType) {
    TeamGameType["Unknown"] = "unknown";
    TeamGameType["Beatout"] = "beat out";
    TeamGameType["KraakDeCode"] = "kraak de code";
})(TeamGameType || (TeamGameType = {}));
export class Team {
    // eslint-disable-next-line max-lines-per-function
    constructor(id, name, members, group, game_type, pin, score, team_level, team_language, schedule, games) {
        this.id = id;
        this.name = name;
        this.members = members;
        this.group = group;
        this.game_type = game_type;
        this.team_level = team_level;
        this.pin = pin;
        this.score = score;
        this.team_level = team_level;
        this.language = team_language;
        this.schedule = schedule;
        this.games = games;
    }
    static load(data) {
        var _a;
        return new Team(data.id, data.name, data.members, (_a = data.group) !== null && _a !== void 0 ? _a : null, data.game_type, data.pin, data.score, data.team_level, data.language, data.schedule, data.games);
    }
    static empty(groupId) {
        return new Team(groupId + '_' + (new Date().getTime()), '', [], groupId, TeamGameType.Beatout, 0, 0, 0, BeatoutLanguage.Dutch, [], []);
    }
    get duration() {
        return this.schedule.length * 20 * 60;
    }
}
const scorefactor = {
    birdsroom: 0.75,
    lasermaze: 4,
    phoneroom: 5,
    coderoom: 3,
    searchroom: 3.5,
    reactionroom: 1.25,
    arcaderoom: 4,
    spiderroom: 5,
    jungleroom: 0.75,
    repeatroom: 3,
    bedroom: 2.25,
    gridroom: 1.75
};
export const getScoresForTeam = (team) => {
    const scores = {};
    team.games.forEach(game => {
        var _a, _b;
        const room = game.room;
        const factor = (_a = scorefactor[room]) !== null && _a !== void 0 ? _a : 1;
        const score = (game.level + 1) * factor;
        if (score > 0 && ((_b = scores[room]) !== null && _b !== void 0 ? _b : 0 < score)) {
            scores[room] = Math.round(score);
        }
    });
    return scores;
};
export const getPrintedDurationTime = (team) => {
    if (team.duration === null)
        return 'N/A';
    const hours = Math.floor(team.duration / 3600);
    const minutes = Math.floor((team.duration % 3600) / 60);
    return `${hours}u${minutes}`;
};
